import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
	const tocLinks = document.querySelectorAll('.toc-link');
	const sections = document.querySelectorAll(".policy-content>[id]");
	const header = document.querySelector('[data-fixed-element]');

	const getHeaderOffset = (threshold = 40) => {
		return header ? header.offsetHeight : threshold;
	};

	const getSectionOffset = sectionId => {
		const section = document.querySelector(sectionId);
		return section ? section.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() : 0;
	};

	const goTo = (offsetPosition, hash) => {
		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth',
		});

		if (hash) {
			history.pushState(null, null, hash);
		}
	};

	const onClickAnchor = event => {
		const isLink = event.target.closest('a') && event.target.tagName === 'A' && event.target.hash;
		if (!isLink) return;
		event.preventDefault();
		const targetId = event.target.getAttribute('href');
		const targetElement = targetId && document.querySelector(targetId);
		if (targetElement) {
			const headerOffset = getHeaderOffset(40);
			const sectionOffset = getSectionOffset(targetId);
			const offsetPosition = sectionOffset - headerOffset;
			goTo(offsetPosition, targetId);
		}
	};

	document.addEventListener('click', onClickAnchor);

	function setActiveTocLink(id) {
		tocLinks.forEach(link => {
			const parent = link.parentElement;
			if (parent) {
				if (link.getAttribute('href') === `#${id}`) {
					parent.setAttribute('data-active', '');
				} else {
					parent.removeAttribute('data-active');
				}
			}
		});
	}

	if (tocLinks.length > 0) {
		gsap.utils.toArray(sections).forEach(section => {
			gsap.to(section, {
				scrollTrigger: {
					trigger: section,
					start: 'top 30%',
					onEnter: self => {
						const target = self.trigger;
						const id = target.getAttribute('id');
						setActiveTocLink(id);
					},
					onEnterBack: self => {
						const target = self.trigger;
						const id = target.getAttribute('id');
						setActiveTocLink(id);
					},
				},
			});
		});
	}
});
